import { __awaiter } from 'tslib';
import { DynamicError } from '../../errors.js';
import { isMobile, isSamsungBrowser } from '../../utils/isMobile.js';
import { normalizeWalletName } from '../../utils/normalizeWalletName/normalizeWalletName.js';
import { SolProvider } from './solProvider.js';
import { SolProviderHelper } from './solProviderHelper.js';

class Phantom extends SolProvider {
    constructor() {
        super(...arguments);
        this.name = 'Phantom';
        this.supportedChains = ['SOL'];
        this.connectedChain = 'SOL';
        this.canConnectViaQrCode = false;
        this.canConnectViaCustodialService = false;
        this.isWalletConnect = false;
        this.solProviderHelper = new SolProviderHelper();
    }
    get key() {
        return normalizeWalletName(this.name);
    }
    setupEventListeners(listeners) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.solProviderHelper._setupEventListeners(Object.assign(Object.assign({}, listeners), { onDisconnect: () => __awaiter(this, void 0, void 0, function* () {
                    // noop for now because phantom sends a disconnect event when the page reloads,
                    // resulting in a log out.
                }) }), this.solProviderHelper.findProvider(this.name));
        });
    }
    teardownEventListeners() {
        this.solProviderHelper._teardownEventListeners(this.name);
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.solProviderHelper.connectWithName(this.name);
        });
    }
    getSigner() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.solProviderHelper.connectWithName(this.name);
        });
    }
    isInstalledOnBrowser() {
        var _a;
        /**
         * When Glow wallet is installed and Phantom isn't, isPhantom will
         * still be true. This added check is to return false in that scenario.
         * It relies on the fact that if both Glow and Phantom are enabled,
         * solana.isGlow will return false.
         */
        return (this.solProviderHelper.isInstalledHelper(this.name) &&
            !((_a = window.solana) === null || _a === void 0 ? void 0 : _a.isGlow));
    }
    fetchPublicAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isInstalledOnBrowser()) {
                return this.solProviderHelper.fetchPublicAddressWithName(this.name);
            }
            const url = encodeURIComponent(window.location.toString());
            const ref = encodeURIComponent(window.location.origin);
            // samsung browser only supports native links, not universal links
            if (isMobile()) {
                if (isSamsungBrowser()) {
                    window.location.assign(`phantom://browse/${url}?ref=${ref}`);
                }
                else {
                    window.location.assign(`https://phantom.app/ul/browse/${url}?ref=${ref}`);
                }
            }
            return;
        });
    }
    signMessage(messageToSign) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.solProviderHelper.signMessageWithName(messageToSign, this.name);
        });
    }
    proveOwnership(messageToSign) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.signMessage(messageToSign);
        });
    }
    supportsNetworkSwitching() {
        return false;
    }
    switchNetwork() {
        return __awaiter(this, void 0, void 0, function* () {
            throw new DynamicError('Not supported');
        });
    }
    getConnectedAccounts() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.solProviderHelper.getConnectedAccountsWithName(this.name);
        });
    }
}

export { Phantom as default };
